module.exports = __webpack_public_path__ + "static/media/ICON_CART.4c58fc3c.svg";